import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import cx from 'classnames'
import {Button, ButtonToolbar, Modal} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import phonez from '../../core/phonez'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import {Contact as PatrimonyContact} from '../../patrimony/models'
import patrimonyI18n from '../../patrimony/i18n'
import i18n from '../i18n'
import style from './TicketCallerCard.less'
import LoaderButton from '../../core/components/LoaderButton'
import OpenTicketCallerCard from './OpenTicketCallerCard'
import {connectForm} from '../../core/redux/form'
import {createValidator, OpenTicketCmd} from '../models'
import {
    CORRECT_CALLER_CMD_UPDATED,
    CORRECT_LOCATION_REFERENCE_CMD_UPDATED,
    updateCorrectCallerCmd,
    updateCorrectLocationReferenceCmd
} from '../actions'
import cache from '../../core/cache'
import uuid from 'node-uuid'
import {apiOption, apiResponse, apiUrl} from '../../core/fetchz'
import config from '../../config'
import {errorStatus} from '../../core/redux/status'

const schemaCache = cache()

function selectSchema(target, {step}) {
    const schema = OpenTicketCmd.selectSchema(target)

    return schemaCache([schema, step], () => {
        if (step == 0.1) {
            return {
                ...schema,
                properties: {
                    company: schema.properties.company,
                    locationRef: schema.properties.locationRef,
                    ticket: {
                        ...schema.properties.ticket,
                        properties: {
                            callerz: schema.properties.ticket.properties.callerz,
                            contactToCallback: schema.properties.ticket.properties.contactToCallback,
                            address: schema.properties.ticket.properties.address
                        },
                        required: ['callerz', 'address']
                    }
                },
                required: ['company', 'locationRef', 'ticket']
            }
        }
        return schema
    })
}

class TicketCallerCard extends Component {
    static propTypes = {
        ticketIdLock: PropTypes.string,
        onSubmit: PropTypes.func
    }

    state = {}

    _init = (props) => {
        const {ticket, dispatch} = props
        const action = {
            locationRef: {
                patrimonyUid: ticket.linkedEntities.patrimony && ticket.linkedEntities.patrimony.uid
            },
            ticket: {
                callerz: {
                    callerType: 'HumanCaller'
                }
            }
        }
        dispatch(updateCorrectCallerCmd(action))
    }

    componentWillMount() {
        this._init(this.props)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.ticket.linkedEntities.clientCompany !== nextProps.ticket.linkedEntities.clientCompany) {
            this._init(nextProps)
        }
    }

    _openCorrectCallerModal = () => {
        this.setState({showModal: true})
        const {dispatch, ticket, cmd} = this.props

        if (ticket.caller.callerInfos.callerType === 'NonReferencedCaller') {
            let medium = ticket.caller.medium[0]
            dispatch({
                type : CORRECT_CALLER_CMD_UPDATED,
                cmd: {
                    ticket: {
                        callerz: {
                            callerType: cmd.ticket.callerz.callerType,
                            status: ticket.caller.status,
                            comment: ticket.caller.comment,
                            namez: {
                                firstName: ticket.caller.name.split(' ')[0],
                                lastName: ticket.caller.name.split(' ').slice(1).join(' ')
                            },
                            medium: {
                                [medium.mediumType.toLowerCase()]: medium.identifier,
                                contactMediumType: medium.mediumType.toLowerCase().replace(/^./, (m) => m.toUpperCase())
                            },
                        }
                    }
                }
            })
        }
    }

    _closeCorrectCallerModal = () => {
        this.setState({showModal: undefined})
    }

    _sendCorrectCallerCmd = () => {
        const {dispatch, cmd, ticket} = this.props
        const {uid: ticketUid} = ticket
        const {namez, uid, ...otherFields} = {...cmd.ticket.callerz}
        const callerName = namez || null
        const callerUid = (uid && uid.uid) || null
        const options = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                caller: {
                    uid: callerUid,
                    name: {
                        ...callerName,
                        nameType: 'CivilName'
                    },
                    ...otherFields,
                },
                commandType: 'CorrectCaller'
            }
        }

        fetch(apiUrl(`${config.api.event.url}/tickets/${ticketUid}`), apiOption(options))
            .then(apiResponse)
            .then(() => {
                this._closeCorrectCallerModal()
                window.location.reload()
            })
            .catch((e) => {
                dispatch(errorStatus(e.message))
            })

    }

    render = () => {
        const {dispatch, ticket, patrimony, ticketIdLock, onSubmit, form, cmd, ...others} = this.props

        const callerName = (caller) => {
            if (ticket.caller.callerInfos.callerType === 'PatrimonyContactCaller' && caller.uid) {
                return (
                    <a href={'/patrimonycontacts/' + caller.uid}>
                        <h5>
                            <span>{caller.name}</span>
                            <Icon icon='plus' size='xs' />
                        </h5>
                    </a>
                )
            }

            return (
                <h5>{caller.name}</h5>
            )
        }

        const isLocked = () => {
            if (ticketIdLock && ticketIdLock != (ticket && ticket.uid)) return true
            return !ticket
        }

        const cardHeader = (title) => (
            <div>
                <h5>{title}</h5>
                {ticket._links.find(linkFinder('CorrectCaller')) &&
                <Button
                    bsStyle='link'
                    onClick={this._openCorrectCallerModal}
                    title={i18n.correctCaller}
                    alt={i18n.correctCaller}
                >
                    <Icon icon='pencil' size='xs' />
                </Button>}
            </div>

        )

        const correctCallerModal = (

            <Modal
                bsSize='large'
                show={this.state.showModal}
                onHide={this._closeCorrectCallerModal}
            >
                <Modal.Header>
                    <Modal.Title>{i18n.callerIdentity}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OpenTicketCallerCard {...{form, cmd, dispatch} } split={true}/>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            // className={cx({disabled: !form.isValid()})}
                            onClick={this._sendCorrectCallerCmd}
                        >
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={this._closeCorrectCallerModal}
                        >
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>

        )

        return (
            <div className={style.default}>
                {correctCallerModal}
                <Card
                    header={cardHeader(i18n.callerIdentity)}
                    {...others}>
                    {!isLocked() && (
                        <div>
                            {callerName(ticket.caller)}
                            {<div>{ticket.caller.status}</div>}
                            {ticket.caller.callerInfos.callerType === 'PatrimonyContactCaller'
                                && (
                                <div className={style.comment}>
                                    {PatrimonyContact.filterLinkedWith(ticket.caller.callerInfos, {patrimony}).map((link, index) => (
                                        <p key={index}>{PatrimonyContact.extractLinkedWith(patrimonyI18n.patrimonyContactLinkTypeEnum, link)}</p>
                                    ))}
                                </div>
                            )}
                            {ticket.caller.callerInfos.callerType === 'ClientCompanyUserCaller' &&
                            (<div className={style.comment}>
                                <p>{patrimonyI18n.patrimonyUserLinkTypeEnum[ticket.caller.callerInfos.userType]}</p>
                            </div>)}

                            <ul className={style.contact}>
                                {ticket.caller.medium && ticket.caller.medium.filter((m) => m.mediumType == 'PHONE').map((medium, index) => (
                                    <li key={index}>
                                        <Icon icon='phone' size='xs' />
                                        <span> {phonez(medium.identifier).format()}</span>
                                    </li>
                                ))}
                            </ul>
                            <ul className={style.contact}>
                                {ticket.caller.medium && ticket.caller.medium.filter((m) => m.mediumType == 'MAIL').map((medium, index) => (
                                    <li key={index}>
                                        <Icon icon='mail' size='xs' />
                                        <span> {medium.identifier}</span>
                                    </li>
                                ))}
                            </ul>
                            <ul className={style.contact}>
                                {ticket.caller.medium && ticket.caller.medium.filter((m) => m.mediumType == 'FAX').map((medium, index) => (
                                    <li key={index}>
                                        <Icon icon='fax' size='xs' />
                                        <span> {phonez(medium.identifier).format()}</span>
                                    </li>
                                ))}
                            </ul>
                            {ticket.caller.comment && (
                                <div className={cx(style.comment, style.warning)}>
                                    <p>{ticket.caller.comment}</p>
                                </div>
                            )}
                            {onSubmit && (
                                <ul className={style.callingGroup}>
                                    <li>
                                        {ticket._links.find(linkFinder('EmitCallTo')) && (
                                            <Button
                                                onClick={(e) => onSubmit(e, 'EmitCallTo', ticket.caller)}>
                                                <p>{i18n.emitCallz}</p>
                                                <Icon icon='emitCall' size='sm' />
                                            </Button>
                                        )}
                                    </li>
                                    <li>
                                        {ticket._links.find(linkFinder('ReceiveCall')) && (
                                            <Button
                                                onClick={(e) => onSubmit(e, 'ReceiveCall', ticket.caller)}>
                                                <p>{i18n.receiveCallz}</p>
                                                <Icon icon='receiveCall' size='sm' />
                                            </Button>
                                        )}
                                    </li>
                                </ul>
                            )}
                        </div>
                    )}
                    {isLocked() && (
                        <div className={style.noTicketInfo}>
                            <span>{i18n.noTicketInfo}</span>
                        </div>
                    )}
                </Card>
            </div>
        )
    }
}

TicketCallerCard = connectForm({
    validator: createValidator(),
    target: 'cmd',
    schema: selectSchema,
    action: CORRECT_CALLER_CMD_UPDATED
})(TicketCallerCard)

TicketCallerCard = connect((state) => ({
    ticket: state.ticket.ticket,
    patrimony: state.patrimony.patrimony,
    cmd: state.ticket.correctCallerCmdUpdate
}))(TicketCallerCard)

export default TicketCallerCard


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketCallerCard.js